import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=256358a6&scoped=true"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256358a6",
  null
  
)

export default component.exports